export default "__VITE_PUBLIC_ASSET__ff948569__"